module.exports = __webpack_public_path__ + "static/img/logo-3-4.cca086c9.png";